import React, { useEffect, useState, useMemo } from "react";

import NoDataFound from "../common/NoDataFound";
import RugbyTableRow from "./RugbyTableRow";
import { loadStyles } from "../../utils/cssLoader";

const RugbyStandingTable = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  sport = "rugby",
  websiteBaseUrl,
  dataPath,
}) => {
  const [clientData, setClientData] = useState(null);


  const data = useMemo(() => {
    const source = dataClient ? clientData : ServerData;
    return source?.data?.table ?? null;
  }, [clientData, ServerData, dataClient]);

  useEffect(() => {
    if (!dataClient) return;

    try {
      const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
      if (!raw) return;

      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed ?? null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);


  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("rugby");
    }
  }, [loadCSS]);


  const sortedData = useMemo(() => {
    return Array.isArray(data)
      ? [...data].sort((a, b) => a?.plc - b?.plc)
      : [];
  }, [data]);

  return (
    <>
      {title && <h1>{title}</h1>}

      {sortedData.length > 0 ? (
        <div className="global_table standing_table rugby">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th><span>Teams</span></th>
                <th>MP</th>
                <th>W</th>
                <th>D</th>
                <th>L</th>
                <th>TP</th>
                <th>PTS</th>
                <th>FORM</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((team, index) => (
                <RugbyTableRow
                  key={team?.id || index}
                  data={team}
                  index={index}
                  sport={sport}
                  websiteBaseUrl={websiteBaseUrl}
                  dataPath={dataPath}
                  dataClient={dataClient}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <NoDataFound />
      )}
    </>
  );
};

export default RugbyStandingTable;
